import React from "react"
import styles from "./Button.module.scss"
const ButtonExtraSmall = (props: any) => {
    return (
        <button {...props} className={props.outline ? styles.button_exsmall_outline : styles.button_exsmall}>
            {props.children}
        </button>
    )
}

export default ButtonExtraSmall
